var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup1000002452(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0307617,
    y: 0.0361328,
    width: 41.9141,
    height: 41.9141,
    rx: 6.44833,
    fill: "#D7D7FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1352_1069)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9891 14.3513L28.1859 11.5496C27.8177 11.1829 27.4055 10.998 26.9464 10.998C26.4873 10.998 25.9812 11.1814 25.66 11.5496L23.7765 13.433L21.6628 15.6832L12.5227 24.8702C12.4773 24.8702 12.4303 24.9157 12.4303 24.9157V24.9626C12.4303 24.9929 12.4152 25.0232 12.3849 25.0535L10.7772 30.0145L10.5938 30.5191L10.4105 31.0691C10.4105 31.0691 10.4105 31.1161 10.365 31.1161C10.3195 31.3904 10.365 31.6222 10.4574 31.8055C10.5029 31.8525 10.5483 31.8979 10.5483 31.9434C10.7317 32.1268 11.0075 32.2646 11.2832 32.2646H11.4681C11.5135 32.2646 11.5605 32.2646 11.5605 32.2177L12.2939 31.9889L17.5306 30.2888C17.623 30.2433 17.6685 30.1978 17.714 30.1509L26.9009 20.9639L29.0587 18.7592L30.9876 16.8758C31.724 16.1878 31.724 15.0393 30.9876 14.3498L30.9891 14.3513Z",
    fill: "url(#paint0_linear_1352_1069)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1352_1069",
    x1: 31.627,
    y1: 10.998,
    x2: 10.3475,
    y2: 32.2775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66E69E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28C3AB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1352_1069"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.1932,
    height: 21.2666,
    fill: "white",
    transform: "translate(10.3481 10.998)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1000002452);
export default __webpack_public_path__ + "static/media/Group-1000002452.c85ca8c4fab5996fde9740a0c1b83cff.svg";
export { ForwardRef as ReactComponent };